import React from 'react';

const DateSelector = ({
  dates = [],
  selectedDate,
  onDateSelect,
  className = '',
  textSize = '11px',
}) => {
  const defaultDates = dates.length === 0 ? generateWeekDates() : dates;

  return (
    <div className={`flex gap-2 ${className}`}>
      {defaultDates.map((date, index) => {
        const isSelected = selectedDate === date.key;

        return (
          <div
            key={date.key}
            onClick={() => onDateSelect && onDateSelect(date.key)}
            className={`
              px-4 py-1 rounded-full cursor-pointer transition-all duration-200 hover:bg-dark-500 border border-solid box-border
              text-sm font-medium select-none flex items-center justify-center
              ${
                isSelected
                  ? 'text-white'
                  : 'bg-white text-[#717784] border-[#717784] hover:bg-gray-50'
              }
            `}
            style={{
              width: '90px',
              backgroundColor: isSelected ? '#717784' : 'white',
              borderColor: '#717784',
            }}>
            <span className="text-11" textSize={textSize}>{date.dayName}</span>
            <span className="ml-1 text-11" textSize={textSize}>{date.dayNumber}</span>
            <span className="ml-1 text-11" textSize={textSize}>{date.month}</span>
          </div>
        );
      })}
    </div>
  );
};

function generateWeekDates() {
  const dates = [];
  const today = new Date();

  for (let i = 0; i < 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    dates.push({
      key: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0'
      )}-${String(date.getDate()).padStart(2, '0')}`,
      dayName: date.toLocaleDateString('en-US', { weekday: 'short' }),
      dayNumber: date.getDate(),
      month: date.toLocaleDateString('en-US', { month: 'short' }),
    });
  }

  return dates;
}

export default DateSelector;
